import * as z from 'zod';
// Base team shape — returned from stage list responses
const NifsTeamSchema = z
    .object({
    id: z.number(),
    name: z.string().nullish(),
    logo: z.object({ url: z.string().nullish() }).loose().nullish(),
})
    .loose();
const NifsTvChannelSchema = z
    .object({
    id: z.number().nullish(),
    uid: z.string().nullish(),
    name: z.string().nullish(),
    type: z.string().nullish(),
})
    .loose();
export const NifsStageMatchSchema = z
    .object({
    id: z.number(),
    uid: z.string(), // "m_2536575" format — needed for ID resolution
    name: z.string(),
    timestamp: z.string(),
    matchStatusId: z.number(),
    homeTeam: NifsTeamSchema,
    awayTeam: NifsTeamSchema,
    tvChannels: z.array(NifsTvChannelSchema).nullish(),
    result: z
        .object({
        homeScore90: z.number().nullish(),
        awayScore90: z.number().nullish(),
    })
        .loose()
        .nullish(),
})
    .loose();
// Detailed match schemas — only available from GET /matches/{id}/, not from stage list
const NifsMatchStreamSchema = z
    .object({
    id: z.number().nullish(),
    uid: z.string().nullish(),
    link: z.string().nullish(),
    radio: z.boolean().nullish(),
    customer: z
        .object({
        id: z.number().nullish(),
        name: z.string().nullish(),
        host: z.string().nullish(),
    })
        .loose()
        .nullish(),
    type: z.string().nullish(),
})
    .loose();
const NifsTeamMatchStatisticsSchema = z
    .object({
    possession: z.number().nullish(),
    shotsTotal: z.number().nullish(),
    shotsOnGoal: z.number().nullish(),
    corners: z.number().nullish(),
    yellowCards: z.number().nullish(),
    redCards: z.number().nullish(),
    fouls: z.number().nullish(),
    offsides: z.number().nullish(),
    freekicks: z.number().nullish(),
})
    .loose();
const NifsMatchEventSchema = z
    .object({
    id: z.number(),
    timeRounded: z.number().nullish(),
    time: z.number().nullish(),
    matchEventTypeId: z.number(),
    team: z
        .object({ id: z.number().nullish(), name: z.string().nullish() })
        .loose()
        .nullish(),
    person: z
        .object({ id: z.number().nullish(), name: z.string().nullish() })
        .loose()
        .nullish(),
    relatedPerson: z
        .object({ id: z.number().nullish(), name: z.string().nullish() })
        .loose()
        .nullish(),
})
    .loose();
const NifsFullMatchTeamSchema = NifsTeamSchema.extend({
    matchStatistics: NifsTeamMatchStatisticsSchema.nullish(),
}).loose();
export const NifsStageSchema = z
    .object({
    id: z.number(),
    name: z.string(),
    fullName: z.string().optional(),
    yearStart: z.number().optional(),
    dateStart: z.string().optional(),
    dateEnd: z.string().optional(),
    season: z.object({ name: z.string() }).loose().optional(),
})
    .loose();
// Full match shape from GET /matches/{id}/
// Extends stage match with broadcast info, half-time scores, events, and statistics
// tvChannels and matchStreams are null for far-future matches, populated closer to match day
export const NifsFullMatchSchema = NifsStageMatchSchema.extend({
    homeTeam: NifsFullMatchTeamSchema,
    awayTeam: NifsFullMatchTeamSchema,
    result: z
        .object({
        homeScore90: z.number().nullish(),
        awayScore90: z.number().nullish(),
        homeScore45: z.number().nullish(),
        awayScore45: z.number().nullish(),
    })
        .loose()
        .nullish(),
    matchStreams: z.array(NifsMatchStreamSchema).nullish(),
    matchEvents: z.array(NifsMatchEventSchema).nullish(),
}).loose();
export const NifsMatchDetailSchema = NifsFullMatchSchema.omit({
    timestamp: true,
    tvChannels: true,
    matchStreams: true,
})
    .extend({
    _syncedAt: z.number(),
})
    .loose();
export const NifsMatchDetailSyncResultSchema = z.strictObject({
    nifsMatchId: z.string(),
});
export const NifsTournamentSyncResultSchema = z.object({
    tournamentId: z.string(),
    tournamentName: z.string(),
    success: z.boolean(),
    roundsCreated: z.number(),
    roundsUpdated: z.number(),
    questionsCreated: z.number(),
    questionsUpdated: z.number(),
    error: z.string().optional(),
});
export const NifsSyncResponseSchema = z.object({
    timestamp: z.string(),
    results: z.array(NifsTournamentSyncResultSchema),
});
//# sourceMappingURL=nifs.js.map